import store from "@packages/store";
import { clearWhitelabelStyle } from "./whitelabelStyle";

export function discardAccountWhitelabel() {
    clearWhitelabelStyle();

    return store.dispatch("accountWhitelabel/clear");
}
